import { IBaseAction, PaginationQuery } from '../../constants';
import { Moment } from 'moment-jalaali'

export interface Rpl {
    airline: string;
    summerSeason: boolean;
    startDate: Moment;
    endDate: Moment;
    id: string;
}

export interface RplsListState {
    data: Array<Rpl>;
    total: 0;
}

export interface RplssListInitialState {
    rplsList: Array<Rpl>;
}
export const GET_RPL_LIST = 'GET_RPL_LIST';
export const GET_RPL_LIST_SUCCESS = 'GET_RPL_LIST_SUCCESS';
export const GET_RPL_LIST_FAILURE = 'GET_RPL_LIST_FAILURE';
interface GetRplsList extends IBaseAction {
    type: typeof GET_RPL_LIST | typeof GET_RPL_LIST_SUCCESS | typeof GET_RPL_LIST_FAILURE;
    payload: RplsListState
}

export class GetRplsListQuery extends PaginationQuery {
    constructor() {
        super();
    }
}

//************* */
export const DOWNLOAD_RPL_EXCEL_SUCCESS = 'DOWNLOAD_RPL_EXCEL_SUCCESS';
export const DOWNLOAD_RPL_EXCEL_FAILURE = 'DOWNLOAD_RPL_EXCEL_FAILURE';
export const DOWNLOAD_RPL_EXCEL = 'DOWNLOAD_RPL_EXCEL';
export interface DownloadRplExcelAction extends IBaseAction {
    type: typeof DOWNLOAD_RPL_EXCEL | typeof DOWNLOAD_RPL_EXCEL_SUCCESS | typeof DOWNLOAD_RPL_EXCEL_FAILURE,
    payload?: {
        data: {
            data: any,
            headers: any
        }
    }
}
//************* */

export type RplArchiveActionTypes = GetRplsList | DownloadRplExcelAction;    